<div class="wrapper" *ngIf="!offer">
    <mat-progress-spinner class="inner" 
        mode="indeterminate"></mat-progress-spinner>
</div>
<mat-card class="offer-card" *ngIf="offer">
    <mat-card-title>
        <mat-form-field class="input-full-width">
          <mat-label>Title</mat-label>
          <input matInput type="text" [(ngModel)]="offer.displayName" />
        </mat-form-field>
      </mat-card-title>
      <mat-card-subtitle>
          <mat-form-field class="input-full-width">
              <mat-label>Description</mat-label>
              <input matInput type="text" [(ngModel)]="offer.details" />
          </mat-form-field>
          <mat-form-field class="input-full-width" >
            <mat-label>Visible In App</mat-label>
            <mat-select [(ngModel)]="offer.visibility">
                <mat-option value="private">No</mat-option>
                <mat-option value="public">Yes</mat-option>
            </mat-select>
          </mat-form-field>
      </mat-card-subtitle>
      <h2>Image</h2>
      <section>
        <ngp-image-picker
          [_config]="imagePickerConf"
          [_imageSrc]="offer.imageUrl"
          ($imageChanged)="onImageChange($event)"
        ></ngp-image-picker>
        <!-- <img mat-card-image [src]="offer.imageUrl" class="offer-image"> -->
      </section>
      <h2>Location Availability</h2>
          <mat-selection-list [(ngModel)]="offer.locationIds" >
                    <mat-list-option *ngFor="let loc of retailer.locations" [value]="loc.id">
                        {{ loc | locationFormat }}
                    </mat-list-option>
                </mat-selection-list>
      <h2>Time Availability</h2>
      <mat-form-field class="date-picker" appearance="fill">
        <mat-label>Start date</mat-label>
        <input matInput [matDatepicker]="startPicker" [(ngModel)]="offer.availability.startDate">
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="date-picker" appearance="fill">
        <mat-label>End date</mat-label>
        <input matInput [matDatepicker]="endPicker" [(ngModel)]="offer.availability.endDate">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      <section>
        <mat-slide-toggle
            [checked]="hasTime"
            (change)="hasTimeChanged($event)"
            >
          Has Specific Times
        </mat-slide-toggle>
        <mat-form-field class="date-picker" appearance="fill" *ngIf="hasTime">
            <mat-label>Available Starting</mat-label>
            <input matInput placeholder="Available Starting" class="timerange"
                [ngxTimepicker]="range" min="12:00 am" max="11:59 pm" [(ngModel)]="offer.availability.startTimeOfDay" readonly>
            <ngx-material-timepicker #range></ngx-material-timepicker>
            </mat-form-field>
        <mat-form-field class="date-picker" appearance="fill" *ngIf="hasTime">
                
            <mat-label>Available Until</mat-label>
            <input matInput placeholder="Available Until" class="timerange"
                [ngxTimepicker]="range" min="12:00 am" max="11:59 pm" [(ngModel)]="offer.availability.endTimeOfDay" readonly>
            <ngx-material-timepicker #range></ngx-material-timepicker>
        </mat-form-field>
        <br />
        <mat-slide-toggle
        [checked]="onPrem"
        (change)="onPremChanged($event)"
        >
          Must be at location to redeem
        </mat-slide-toggle>
      </section>
<br />
      <section>
          <h2>Code Options</h2>


          <mat-radio-group class="code-options-group"
          [(ngModel)]="offer.codeDisplayType" #radioGroup="matRadioGroup">
          <mat-radio-button [value]="1">Show Code as Text Only</mat-radio-button>
          <mat-radio-button [value]="5">Show Barcode and Text</mat-radio-button>
          <mat-radio-button [value]="3">Show QR code and Text</mat-radio-button>
          <mat-radio-button [value]="7">Show Everything</mat-radio-button>
        </mat-radio-group>
        <br />
        <mat-form-field class="input-half-width">
            <mat-label>Code for this offer</mat-label>
            <input matInput type="text" [(ngModel)]="offer.redeemCode" />
        </mat-form-field>
        <mat-form-field class="input-full-width">
            <mat-label>Additional redemption instructions</mat-label>
            <input matInput type="text" [(ngModel)]="offer.redeemInstructions" />
        </mat-form-field>
      </section>
      <mat-card-actions>
        <button mat-button color="primary" (click)="saveOffer()">SAVE</button>
        <button mat-button color="warn" *ngIf="offer.id" (click)="deleteOffer()">DELETE</button>
    </mat-card-actions>
</mat-card>